// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__dMJ4-","title":"Loading_title__DG2Dw","loop":"Loading_loop__pRh9D","subtitle":"Loading_subtitle__itHEW","waitGif":"Loading_waitGif__wyCsc"};